import AuthLayout from '@/layouts/AuthLayout';
import Login from '@/views/auth/Login';
import Register from '@/views/auth/Register';

const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    meta: {
      disableIfLoggedIn: true
    },
    children: [
      {
        path: 'login',
        component: Login,
        name: 'Login'
      },
      // {
      //   path: 'register',
      //   component: Register,
      //   name: 'Register'
      // },
    ]
  }
];

export default routes;